import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './CategoryProducts.css';
import MarketplaceHeader from '../MarketPlaceHeader/marketPlaceHeader';

/* ─────────────────────────────────────────────
   Données du catalogue
   (mêmes produits qu'avant + note, avis, et prix barré pour la démo des promos)
   ───────────────────────────────────────────── */
const allProducts = [
  { id: 1, name: 'Robe Élégante', price: 120, oldPrice: 150, subcategory: 'Robes', category: 'Mode & Fashion', brand: 'Elegance', inStock: true, sizes: ['S', 'M', 'L'], colors: ['Noir', 'Bleu', 'Rouge'], rating: 4, reviews: 128 },
  { id: 2, name: 'Pantalon Chic', price: 80, subcategory: 'Pantalons', category: 'Mode & Fashion', brand: 'Style', inStock: true, sizes: ['S', 'M', 'L', 'XL'], colors: ['Gris', 'Noir', 'Beige'], rating: 5, reviews: 64 },
  { id: 3, name: 'Veste en Cuir', price: 200, subcategory: 'Vestes', category: 'Mode & Fashion', brand: 'LeatherCo', inStock: false, sizes: ['M', 'L'], colors: ['Noir', 'Marron'], rating: 4, reviews: 41 },
  { id: 4, name: 'Chemise en Lin', price: 65, subcategory: 'Chemises', category: 'Mode & Fashion', brand: 'CasualWear', inStock: true, sizes: ['S', 'M', 'L', 'XL'], colors: ['Blanc', 'Bleu Clair'], rating: 3, reviews: 19 },
  { id: 5, name: 'Écharpe en Soie', price: 45, subcategory: 'Accessoires', category: 'Mode & Fashion', brand: 'SilkTrend', inStock: true, colors: ['Vert', 'Rose'], rating: 4, reviews: 22 },
  { id: 6, name: "Bottes d'Hiver", price: 150, subcategory: 'Chaussures', category: 'Mode & Fashion', brand: 'WinterStep', inStock: false, sizes: ['38', '39', '40'], colors: ['Noir', 'Gris'], rating: 4, reviews: 37 },
  { id: 7, name: 'Robe Soirée', price: 450, subcategory: 'Robes', category: 'Mode & Fashion', brand: 'Elegance', inStock: true, sizes: ['S', 'M', 'L'], colors: ['Noir', 'Or', 'Argent'], rating: 5, reviews: 203 },
  { id: 8, name: 'Robe Chic', price: 80, subcategory: 'Robes', category: 'Mode & Fashion', brand: 'Style', inStock: true, sizes: ['S', 'M', 'L'], colors: ['Bleu', 'Blanc', 'Rose'], rating: 4, reviews: 55 },
  { id: 9, name: 'Robe en Cuir', price: 300, oldPrice: 340, subcategory: 'Robes', category: 'Mode & Fashion', brand: 'LeatherCo', inStock: false, sizes: ['S', 'M'], colors: ['Noir', 'Marron'], rating: 4, reviews: 12 },
  { id: 10, name: 'Téléviseur LED', price: 300, subcategory: 'Téléviseurs', category: 'Électronique', brand: 'TechWorld', inStock: true, rating: 4, reviews: 88 },
  { id: 11, name: 'Iphone 17 Pro Max', price: 2500, subcategory: 'Smartphones', category: 'Électronique', brand: 'TechTrend', inStock: true, colors: ['Noir', 'Argent', 'Or'], rating: 5, reviews: 312 },
  { id: 12, name: 'Écouteurs Sans Fil', price: 80, oldPrice: 100, subcategory: 'Audio', category: 'Électronique', brand: 'SoundWave', inStock: false, colors: ['Blanc', 'Noir'], rating: 4, reviews: 76 },
  { id: 13, name: 'Tablette 10 Pouces', price: 250, subcategory: 'Tablettes', category: 'Électronique', brand: 'TechWorld', inStock: true, colors: ['Gris', 'Noir'], rating: 4, reviews: 45 },
  { id: 14, name: 'Enceinte Bluetooth', price: 120, subcategory: 'Audio', category: 'Électronique', brand: 'SoundVibe', inStock: true, colors: ['Noir', 'Bleu'], rating: 3, reviews: 29 },
  { id: 15, name: 'Caméra de Surveillance', price: 180, subcategory: 'Sécurité', category: 'Électronique', brand: 'SafeView', inStock: false, rating: 3, reviews: 14 },
  { id: 16, name: 'Canapé Moderne', price: 450, subcategory: 'Mobilier', category: 'Maison & Jardin', brand: 'HomeLux', inStock: true, rating: 5, reviews: 61 },
  { id: 17, name: 'Table en Bois', price: 300, subcategory: 'Mobilier', category: 'Maison & Jardin', brand: 'WoodCraft', inStock: true, rating: 4, reviews: 33 },
  { id: 18, name: 'Lampe de Chevet', price: 40, subcategory: 'Éclairage', category: 'Maison & Jardin', brand: 'LightHome', inStock: false, rating: 3, reviews: 9 },
  { id: 19, name: 'Tapis Persan', price: 200, subcategory: 'Décoration', category: 'Maison & Jardin', brand: 'DecorTrend', inStock: true, rating: 4, reviews: 27 },
  { id: 20, name: "Plante d'Intérieur", price: 25, subcategory: 'Jardin', category: 'Maison & Jardin', brand: 'GreenLife', inStock: true, rating: 5, reviews: 18 },
  { id: 21, name: 'Étagère Murale', price: 90, subcategory: 'Rangement', category: 'Maison & Jardin', brand: 'HomeLux', inStock: false, rating: 4, reviews: 15 },
  { id: 22, name: 'Crème Hydratante', price: 25, subcategory: 'Soins de la peau', category: 'Beauté & Santé', brand: 'SkinCare', inStock: false, rating: 4, reviews: 52 },
  { id: 23, name: 'Parfum Floral', price: 60, subcategory: 'Parfums', category: 'Beauté & Santé', brand: 'FragranceCo', inStock: true, rating: 5, reviews: 71 },
  { id: 24, name: 'Masque Visage', price: 15, subcategory: 'Soins de la peau', category: 'Beauté & Santé', brand: 'GlowUp', inStock: true, rating: 4, reviews: 38 },
  { id: 25, name: 'Shampoing Bio', price: 20, subcategory: 'Soins capillaires', category: 'Beauté & Santé', brand: 'NatureHair', inStock: false, rating: 3, reviews: 21 },
  { id: 26, name: 'Sérum Anti-Âge', price: 50, subcategory: 'Soins de la peau', category: 'Beauté & Santé', brand: 'YouthGlow', inStock: true, rating: 5, reviews: 94 },
  { id: 27, name: 'Baume à Lèvres', price: 10, subcategory: 'Soins des lèvres', category: 'Beauté & Santé', brand: 'LipCare', inStock: true, rating: 4, reviews: 16 },
];

const COLOR_HEX = {
  Noir: '#111111', Bleu: '#2f5aa8', Rouge: '#b33028', Gris: '#8a8a8a',
  Beige: '#d8c7a1', Marron: '#6b4423', Blanc: '#f2efe6', 'Bleu Clair': '#8fb8dd',
  Vert: '#3f7d4e', Rose: '#d98aa3', Or: '#c9a84c', Argent: '#c7c9cf',
};

const ITEMS_PER_PAGE = 8;

const DEFAULT_FILTERS = {
  category: '',
  subcategory: '',
  brands: [],
  sizes: [],
  colors: [],
  priceRange: [0, 2500],
  minRating: 0,
  inStock: false,
  onSale: false,
  sortBy: 'default',
  search: '',
};

const normalize = (str) =>
  str ? str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase() : '';

const readIds = (key) => {
  try {
    const raw = localStorage.getItem(key);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
};

/* ─────────────────────────────────────────────
   Étoiles de notation
   ───────────────────────────────────────────── */
const Stars = ({ rating = 0, reviews }) => (
  <div className="p-rating">
    <span className="p-stars" aria-hidden="true">
      {'★'.repeat(Math.round(rating))}
      <span className="dim">{'★'.repeat(5 - Math.round(rating))}</span>
    </span>
    {typeof reviews === 'number' && <span className="p-reviews">({reviews})</span>}
  </div>
);

/* ─────────────────────────────────────────────
   Panneau de filtres (accordéon) — partagé entre
   la sidebar desktop et le tiroir mobile
   ───────────────────────────────────────────── */
const FilterPanel = ({
  filters, setFilters, resetFilters, subcategories, brands, sizes, colors, appliedChips,
}) => {
  const toggleArrayValue = (key, value) => {
    setFilters((f) => {
      const list = f[key];
      const next = list.includes(value) ? list.filter((v) => v !== value) : [...list, value];
      return { ...f, [key]: next };
    });
  };

  const setPrice = (index, value) => {
    const num = value === '' ? (index === 0 ? 0 : 2500) : Math.max(0, parseInt(value, 10) || 0);
    setFilters((f) => {
      const next = [...f.priceRange];
      next[index] = num;
      return { ...f, priceRange: next };
    });
  };

  const pricePresets = [[0, 50], [50, 150], [150, 300], [300, 2500]];

  return (
    <>
      <div className="fp-head">
        <h3>Filtres</h3>
        {appliedChips.length > 0 && (
          <button type="button" className="fp-reset" onClick={resetFilters}>Réinitialiser</button>
        )}
      </div>

      {appliedChips.length > 0 && (
        <div className="fp-applied">
          {appliedChips.map((chip) => (
            <span key={chip.key} className="fp-chip">
              {chip.label}
              <span onClick={chip.onRemove} role="button" aria-label={`Retirer le filtre ${chip.label}`}>✕</span>
            </span>
          ))}
        </div>
      )}

      {subcategories.length > 0 && (
        <details className="fp-acc" open>
          <summary>Sous-catégories</summary>
          <div className="fp-body fp-tree">
            {subcategories.map((sub) => (
              <button
                type="button"
                key={sub}
                className={filters.subcategory === sub ? 'on' : ''}
                onClick={() => setFilters((f) => ({ ...f, subcategory: f.subcategory === sub ? '' : sub }))}
              >
                {sub}
              </button>
            ))}
          </div>
        </details>
      )}

      <details className="fp-acc" open>
        <summary>Prix</summary>
        <div className="fp-body">
          <div className="fp-price-row">
            <input type="number" min="0" placeholder="Min €" value={filters.priceRange[0]} onChange={(e) => setPrice(0, e.target.value)} />
            <span>—</span>
            <input type="number" min="0" placeholder="Max €" value={filters.priceRange[1]} onChange={(e) => setPrice(1, e.target.value)} />
          </div>
          <div className="fp-presets">
            {pricePresets.map(([min, max]) => (
              <button
                type="button"
                key={`${min}-${max}`}
                onClick={() => setFilters((f) => ({ ...f, priceRange: [min, max] }))}
              >
                {max === 2500 ? `${min}€+` : `${min}–${max}€`}
              </button>
            ))}
          </div>
        </div>
      </details>

      {brands.length > 0 && (
        <details className="fp-acc">
          <summary>Marque</summary>
          <div className="fp-body fp-checklist">
            {brands.map((brand) => (
              <label key={brand}>
                <input
                  type="checkbox"
                  checked={filters.brands.includes(brand)}
                  onChange={() => toggleArrayValue('brands', brand)}
                />
                {brand}
              </label>
            ))}
          </div>
        </details>
      )}

      {sizes.length > 0 && (
        <details className="fp-acc">
          <summary>Taille</summary>
          <div className="fp-body fp-presets">
            {sizes.map((size) => (
              <button
                type="button"
                key={size}
                className={filters.sizes.includes(size) ? 'on' : ''}
                onClick={() => toggleArrayValue('sizes', size)}
              >
                {size}
              </button>
            ))}
          </div>
        </details>
      )}

      {colors.length > 0 && (
        <details className="fp-acc">
          <summary>Couleur</summary>
          <div className="fp-body fp-swatches">
            {colors.map((color) => (
              <button
                type="button"
                key={color}
                className={`fp-sw${filters.colors.includes(color) ? ' on' : ''}`}
                style={{ background: COLOR_HEX[color] || '#666' }}
                title={color}
                aria-label={`Couleur ${color}`}
                onClick={() => toggleArrayValue('colors', color)}
              />
            ))}
          </div>
        </details>
      )}

      <details className="fp-acc">
        <summary>Avis clients</summary>
        <div className="fp-body fp-stars-filter">
          {[4, 3, 0].map((min) => (
            <button
              type="button"
              key={min}
              className={filters.minRating === min ? 'on' : ''}
              onClick={() => setFilters((f) => ({ ...f, minRating: min }))}
            >
              {min === 0 ? 'Toutes les notes' : <>{'★'.repeat(min)}<span className="dim">{'★'.repeat(5 - min)}</span> &amp; plus</>}
            </button>
          ))}
        </div>
      </details>

      <details className="fp-acc" open>
        <summary>Disponibilité</summary>
        <div className="fp-body fp-checklist">
          <label>
            <input type="checkbox" checked={filters.inStock} onChange={(e) => setFilters((f) => ({ ...f, inStock: e.target.checked }))} />
            En stock uniquement
          </label>
          <label>
            <input type="checkbox" checked={filters.onSale} onChange={(e) => setFilters((f) => ({ ...f, onSale: e.target.checked }))} />
            En promotion
          </label>
        </div>
      </details>
    </>
  );
};

/* ─────────────────────────────────────────────
   Composant principal
   ───────────────────────────────────────────── */
const CategoryProducts = () => {
  const navigate = useNavigate();

  const [filters, setFilters] = useState(DEFAULT_FILTERS);
  const [currentPage, setCurrentPage] = useState(1);
  const [viewMode, setViewMode] = useState('grid');
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [quickViewProduct, setQuickViewProduct] = useState(null);
  const [cartIds, setCartIds] = useState(() => readIds('mwg_cart'));
  const [favIds, setFavIds] = useState(() => readIds('mwg_favorites'));
  const [addedFlash, setAddedFlash] = useState(null);

  useEffect(() => {
    try { localStorage.setItem('mwg_cart', JSON.stringify(cartIds)); } catch {}
  }, [cartIds]);
  useEffect(() => {
    try { localStorage.setItem('mwg_favorites', JSON.stringify(favIds)); } catch {}
  }, [favIds]);

  // Catégories réellement présentes dans le catalogue → alimente la barre du header
  const uniqueCategories = useMemo(
    () => [...new Set(allProducts.map((p) => p.category))],
    []
  );

  // Produits de la catégorie active (base sur laquelle les sous-filtres se calculent)
  const categoryProducts = useMemo(() => {
    if (!filters.category) return allProducts;
    return allProducts.filter((p) => normalize(p.category) === normalize(filters.category));
  }, [filters.category]);

  const subcategories = useMemo(
    () => [...new Set(categoryProducts.map((p) => p.subcategory).filter(Boolean))],
    [categoryProducts]
  );
  const brands = useMemo(
    () => [...new Set(categoryProducts.map((p) => p.brand).filter(Boolean))],
    [categoryProducts]
  );
  const sizesAvailable = useMemo(
    () => [...new Set(categoryProducts.flatMap((p) => p.sizes || []))],
    [categoryProducts]
  );
  const colorsAvailable = useMemo(
    () => [...new Set(categoryProducts.flatMap((p) => p.colors || []))],
    [categoryProducts]
  );

  // Pipeline de filtrage + tri
  const filteredProducts = useMemo(() => {
    let list = categoryProducts.filter((p) => {
      if (filters.subcategory && normalize(p.subcategory) !== normalize(filters.subcategory)) return false;
      if (filters.brands.length && !filters.brands.includes(p.brand)) return false;
      if (filters.sizes.length && !(p.sizes || []).some((s) => filters.sizes.includes(s))) return false;
      if (filters.colors.length && !(p.colors || []).some((c) => filters.colors.includes(c))) return false;
      if (p.price < filters.priceRange[0] || p.price > filters.priceRange[1]) return false;
      if (filters.minRating && (p.rating || 0) < filters.minRating) return false;
      if (filters.inStock && !p.inStock) return false;
      if (filters.onSale && !(p.oldPrice && p.oldPrice > p.price)) return false;
      if (filters.search && !normalize(p.name).includes(normalize(filters.search))) return false;
      return true;
    });

    switch (filters.sortBy) {
      case 'priceLowToHigh': list = [...list].sort((a, b) => a.price - b.price); break;
      case 'priceHighToLow': list = [...list].sort((a, b) => b.price - a.price); break;
      case 'rating': list = [...list].sort((a, b) => (b.rating || 0) - (a.rating || 0)); break;
      case 'newest': list = [...list].sort((a, b) => b.id - a.id); break;
      default: break;
    }
    return list;
  }, [categoryProducts, filters]);

  // Réinitialise la pagination à chaque changement de filtre
  useEffect(() => { setCurrentPage(1); }, [filters]);

  const totalPages = Math.max(1, Math.ceil(filteredProducts.length / ITEMS_PER_PAGE));
  const pageProducts = filteredProducts.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  /* ── Handlers ── */
  const handleCategoryChange = useCallback((cat) => {
    setFilters((f) => ({ ...DEFAULT_FILTERS, category: cat, search: f.search, sortBy: f.sortBy }));
  }, []);

  const resetFilters = useCallback(() => {
    setFilters((f) => ({
      ...DEFAULT_FILTERS,
      category: f.category,
      search: f.search,
      sortBy: f.sortBy,
    }));
  }, []);

  const handleProductClick = (id) => navigate(`/product/${id}`);

  const toggleFavorite = (id) => {
    setFavIds((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  const addToCart = (id) => {
    setCartIds((prev) => [...prev, id]);
    setAddedFlash(id);
    setTimeout(() => setAddedFlash((cur) => (cur === id ? null : cur)), 1200);
  };

  /* ── Chips de filtres actifs (pour la sidebar/le tiroir) ── */
  const appliedChips = useMemo(() => {
    const chips = [];
    if (filters.subcategory) chips.push({ key: 'sub', label: filters.subcategory, onRemove: () => setFilters((f) => ({ ...f, subcategory: '' })) });
    filters.brands.forEach((b) => chips.push({ key: `b-${b}`, label: b, onRemove: () => setFilters((f) => ({ ...f, brands: f.brands.filter((x) => x !== b) })) }));
    filters.sizes.forEach((s) => chips.push({ key: `s-${s}`, label: `Taille ${s}`, onRemove: () => setFilters((f) => ({ ...f, sizes: f.sizes.filter((x) => x !== s) })) }));
    filters.colors.forEach((c) => chips.push({ key: `c-${c}`, label: c, onRemove: () => setFilters((f) => ({ ...f, colors: f.colors.filter((x) => x !== c) })) }));
    if (filters.priceRange[0] !== 0 || filters.priceRange[1] !== 2500) {
      chips.push({ key: 'price', label: `${filters.priceRange[0]}–${filters.priceRange[1]}€`, onRemove: () => setFilters((f) => ({ ...f, priceRange: [0, 2500] })) });
    }
    if (filters.minRating) chips.push({ key: 'rating', label: `${filters.minRating}★ et plus`, onRemove: () => setFilters((f) => ({ ...f, minRating: 0 })) });
    if (filters.inStock) chips.push({ key: 'stock', label: 'En stock', onRemove: () => setFilters((f) => ({ ...f, inStock: false })) });
    if (filters.onSale) chips.push({ key: 'sale', label: 'Promotion', onRemove: () => setFilters((f) => ({ ...f, onSale: false })) });
    return chips;
  }, [filters]);

  const activeFilterCount = appliedChips.length;

  const filterPanelProps = {
    filters, setFilters, resetFilters, subcategories, brands,
    sizes: sizesAvailable, colors: colorsAvailable, appliedChips,
  };

  return (
    <div className="mkt-page">
      <MarketplaceHeader
        categories={uniqueCategories}
        activeCategory={filters.category}
        onCategoryChange={handleCategoryChange}
        searchValue={filters.search}
        onSearchChange={(v) => setFilters((f) => ({ ...f, search: v }))}
        cartCount={cartIds.length}
        favCount={favIds.length}
      />

      <nav className="mkt-crumb" aria-label="Fil d'Ariane">
        <span onClick={() => handleCategoryChange('')} role="button">Accueil</span>
        {filters.category && (
          <>
            {' / '}
            <span onClick={() => setFilters((f) => ({ ...f, subcategory: '' }))} role="button">{filters.category}</span>
          </>
        )}
        {filters.subcategory && <> {' / '}<b>{filters.subcategory}</b></>}
      </nav>

      <div className="mkt-layout">
        {/* ── Sidebar desktop ── */}
        <aside className="mkt-sidebar">
          <FilterPanel {...filterPanelProps} />
        </aside>

        {/* ── Colonne principale ── */}
        <main className="mkt-main">
          <div className="mkt-toolbar">
            <span className="mkt-count">
              {filteredProducts.length} produit{filteredProducts.length !== 1 ? 's' : ''} trouvé{filteredProducts.length !== 1 ? 's' : ''}
            </span>
            <div className="mkt-toolbar-right">
              <select
                className="mkt-sel"
                value={filters.sortBy}
                onChange={(e) => setFilters((f) => ({ ...f, sortBy: e.target.value }))}
                aria-label="Trier les produits"
              >
                <option value="default">Trier : Pertinence</option>
                <option value="priceLowToHigh">Prix croissant</option>
                <option value="priceHighToLow">Prix décroissant</option>
                <option value="rating">Mieux notés</option>
                <option value="newest">Nouveautés</option>
              </select>
              <div className="mkt-viewtoggle">
                <button type="button" className={viewMode === 'grid' ? 'on' : ''} onClick={() => setViewMode('grid')} aria-label="Vue grille" aria-pressed={viewMode === 'grid'}>▦</button>
                <button type="button" className={viewMode === 'list' ? 'on' : ''} onClick={() => setViewMode('list')} aria-label="Vue liste" aria-pressed={viewMode === 'list'}>☰</button>
              </div>
            </div>
          </div>

          {pageProducts.length > 0 ? (
            <div className={`mkt-grid${viewMode === 'list' ? ' is-list' : ''}`}>
              {pageProducts.map((product) => {
                const isFav = favIds.includes(product.id);
                const isOnSale = product.oldPrice && product.oldPrice > product.price;
                const discount = isOnSale ? Math.round(100 - (product.price / product.oldPrice) * 100) : 0;
                return (
                  <div key={product.id} className="mkt-card" onClick={() => handleProductClick(product.id)} role="button" tabIndex={0}>
                    <div className="mkt-thumb">
                      <img
                        src={`/images/MarketPlace/${product.name.replace(/\s+/g, '_').toLowerCase()}.jpg`}
                        alt={product.name}
                        loading="lazy"
                        onError={(e) => { e.target.src = '/images/MarketPlace/placeholder.jpg'; }}
                      />
                      {isOnSale && <span className="mkt-badge-promo">-{discount}%</span>}
                      <button
                        type="button"
                        className={`mkt-fav${isFav ? ' on' : ''}`}
                        onClick={(e) => { e.stopPropagation(); toggleFavorite(product.id); }}
                        aria-label={isFav ? 'Retirer des favoris' : 'Ajouter aux favoris'}
                        aria-pressed={isFav}
                      >
                        {isFav ? '♥' : '♡'}
                      </button>
                      <button
                        type="button"
                        className="mkt-quickview"
                        onClick={(e) => { e.stopPropagation(); setQuickViewProduct(product); }}
                      >
                        Aperçu rapide
                      </button>
                    </div>
                    <div className="mkt-cbody">
                      <div className="mkt-brand">{product.brand}</div>
                      <h4>{product.name}</h4>
                      <Stars rating={product.rating} reviews={product.reviews} />
                      <div className="mkt-price-line">
                        {isOnSale && <span className="mkt-old-price">{product.oldPrice} €</span>}
                        <span className="mkt-price">{product.price} €</span>
                      </div>
                      <div className="mkt-stock">
                        {product.inStock
                          ? <span className="ok">● Disponible</span>
                          : <span className="no">● Rupture</span>}
                      </div>
                      <button
                        type="button"
                        className="mkt-addcart"
                        disabled={!product.inStock}
                        onClick={(e) => { e.stopPropagation(); addToCart(product.id); }}
                      >
                        {addedFlash === product.id ? 'Ajouté ✓' : product.inStock ? 'Ajouter au panier' : 'Indisponible'}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="mkt-empty">
              <p>Aucun produit ne correspond à ces filtres.</p>
              <button type="button" onClick={resetFilters}>Réinitialiser les filtres</button>
            </div>
          )}

          {totalPages > 1 && (
            <div className="mkt-pagination">
              <button type="button" disabled={currentPage === 1} onClick={() => setCurrentPage((p) => Math.max(1, p - 1))} aria-label="Page précédente">‹</button>
              {Array.from({ length: totalPages }, (_, i) => i + 1)
                .filter((p) => p === 1 || p === totalPages || Math.abs(p - currentPage) <= 1)
                .reduce((acc, p, i, arr) => {
                  if (i > 0 && p - arr[i - 1] > 1) acc.push('…');
                  acc.push(p);
                  return acc;
                }, [])
                .map((p, i) =>
                  p === '…'
                    ? <span key={`gap-${i}`} className="mkt-page-gap">…</span>
                    : (
                      <button
                        type="button"
                        key={p}
                        className={p === currentPage ? 'on' : ''}
                        onClick={() => setCurrentPage(p)}
                        aria-current={p === currentPage ? 'page' : undefined}
                      >
                        {p}
                      </button>
                    )
                )}
              <button type="button" disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))} aria-label="Page suivante">›</button>
            </div>
          )}
        </main>
      </div>

      {/* ── Bouton flottant filtres (mobile) ── */}
      <button type="button" className="mkt-fab" onClick={() => setIsDrawerOpen(true)}>
        ☰ Filtres{activeFilterCount > 0 ? ` (${activeFilterCount})` : ''}
      </button>

      {/* ── Tiroir filtres (mobile) ── */}
      <div className={`mkt-drawer-backdrop${isDrawerOpen ? ' open' : ''}`} onClick={() => setIsDrawerOpen(false)} />
      <div className={`mkt-drawer${isDrawerOpen ? ' open' : ''}`} role="dialog" aria-modal="true" aria-label="Filtres">
        <div className="mkt-drawer-head">
          <h3>Filtres</h3>
          <button type="button" onClick={() => setIsDrawerOpen(false)} aria-label="Fermer">✕</button>
        </div>
        <FilterPanel {...filterPanelProps} />
        <button type="button" className="mkt-drawer-apply" onClick={() => setIsDrawerOpen(false)}>
          Voir {filteredProducts.length} résultat{filteredProducts.length !== 1 ? 's' : ''}
        </button>
      </div>

      {/* ── Modal aperçu rapide ── */}
      {quickViewProduct && (
        <div className="mkt-qv-backdrop" onClick={() => setQuickViewProduct(null)}>
          <div className="mkt-qv-modal" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="mkt-qv-close" onClick={() => setQuickViewProduct(null)} aria-label="Fermer l'aperçu">✕</button>
            <img
              src={`/images/MarketPlace/${quickViewProduct.name.replace(/\s+/g, '_').toLowerCase()}.jpg`}
              alt={quickViewProduct.name}
              onError={(e) => { e.target.src = '/images/MarketPlace/placeholder.jpg'; }}
            />
            <div className="mkt-qv-info">
              <div className="mkt-brand">{quickViewProduct.brand}</div>
              <h3>{quickViewProduct.name}</h3>
              <Stars rating={quickViewProduct.rating} reviews={quickViewProduct.reviews} />
              <div className="mkt-price-line">
                {quickViewProduct.oldPrice && quickViewProduct.oldPrice > quickViewProduct.price && (
                  <span className="mkt-old-price">{quickViewProduct.oldPrice} €</span>
                )}
                <span className="mkt-price">{quickViewProduct.price} €</span>
              </div>
              <div className="mkt-qv-actions">
                <button
                  type="button"
                  className="mkt-addcart"
                  disabled={!quickViewProduct.inStock}
                  onClick={() => { addToCart(quickViewProduct.id); setQuickViewProduct(null); }}
                >
                  {quickViewProduct.inStock ? 'Ajouter au panier' : 'Indisponible'}
                </button>
                <button type="button" className="mkt-qv-full" onClick={() => handleProductClick(quickViewProduct.id)}>
                  Voir la fiche complète →
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryProducts;